type Props = {
  className?: string;
  busy?: boolean;
  text?: string;
  onCopy: () => void;
};

/**
 * 1.3 — кнопка в шапке: скопировать гостевую ссылку-редактор.
 * Состояние берётся из useBoardShareLinkCopy у родителя.
 */
export function BoardCopyShareLinkButton({
  className = "wb-btn wb-btn--ghost wb-btn--sm",
  busy = false,
  text = "Ссылка",
  onCopy,
}: Props) {
  const copied = text.startsWith("✓");
  const failed = text === "Не удалось";
  return (
    <button
      type="button"
      className={`${className}${copied ? " is-copied" : ""}${failed ? " is-error" : ""}`}
      title="Скопировать гостевую ссылку (редактор) для учеников"
      disabled={busy}
      onClick={() => void onCopy()}
    >
      {text}
    </button>
  );
}
